import React from "react";

const Preloader = () => {
  return (
    <>
      <div className="preloader ">
        <div className="preloader-inner">
          <span className="loader" />
        </div>
      </div>
    </>
  );
};

export default Preloader;
